import { render } from "@/nano";
import { APP_CONTEXT, BASE_API, OSS_URL } from "./constants/config";

import "./App.less";

render.init({
  // 应用信息
  name: "htp-admin",
  version: "1.0.1",
  context: APP_CONTEXT,
  appid: "nano75f20844cc79402d",
  // 服务配置
  server: {
    // 基础URL
    baseURL: BASE_API,
    // 请求超时
    timeout: 50 * 1000,
    // Axios
    axios: {
      // 创建配置
      config: {},
    },
    // 对象存储
    oss: {
      // URL
      baseURL: OSS_URL,
      // 上传 URL
      uploadURL: "/api/oss/uploadFile",
    },
  },
  // 路由配置
  router: {
    // 白名单
    ignores: [
      "/login"
    ],
    // 登录路径
    loginPath: "/login",
    // 已登录路径
    loginedPath: "/",
    // 包装组件
    wrapper: "wrappers/auth",
    // 路由规则
    routes: [
      { path: "/login", component: "pages/login", },
      { path: "/404", component: "pages/error/404", },
    ],
  },
}, document.getElementById("root"));
